export { Modal, useModal } from "./modal";
export type { ModalProps } from "./modal";
